module.exports = __webpack_public_path__ + "img/magnolia.f10aacc7.png";